<template>
  <div class="party-list-wrapper" v-loading="loading">
    <ul v-if="partyAcList.length > 0">
      <li class="item" v-for="(item, index) in partyAcList" :key="index">
        <router-link :to="`m-content/${item.articleid}`" class="img-box">
          <img :src="item.photo" alt="" srcset="" />
        </router-link>
        <div class="content-box">
          <router-link :to="`m-content/${item.articleid}`" class="title">
            {{ item.title }}
          </router-link>
          <p class="digest">{{ item.summary }}</p>
          <!-- <p class="digest">京哈时间撒娇和健康的吉萨还是九回复内容蛤科进士京哈时间撒娇和健康的吉萨还是九回复内容蛤科进士安徽省</p> -->
          <p class="info">
            <span class="author">{{ item.author }}</span>
            <!-- <i class="line">|</i> -->
            <span class="date">{{ item.issue_time }}</span>
          </p>
        </div>
      </li>
    </ul>
    <div class="no-data" v-else>
      暂无数据
    </div>
  </div>
</template>
<script>
export default {
  name: 'party-list',
  data() {
    return {
      partyAcList: [],
      loading: false
    };
  },
  created() {
    this.requestList();
  },
  methods: {
    async requestList() {
      this.loading = true;
      try {
        const res = await this.$http.post('cg/commonRequest', {
          method: 'pinfo.party.building.list',
          token: ''
        });
        if (res.code === 200) {
          this.partyAcList = res.data;
          this.partyAcList.forEach(x => {
            x.issue_time = x.issue_time.split(' ')[0];
          });
          this.loading = false;
        } else {
          this.$message.error(res.msg);
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.party-list-wrapper {
  padding: 0 0.2rem;
  ul {
    min-height: 6rem;
  }
  .item {
    display: flex;
    align-items: center;
    padding: 0.28rem 0;
    border-bottom: solid 0.02rem #e6e6e6;
    height: 1.14rem;
    .img-box {
      display: block;
      width: 1.9rem;
      height: 1.14rem;
      background: #ccc;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .content-box {
      position: relative;
      flex: 1;
      height: 100%;
      margin-left: 0.2rem;
      .title {
        color: #4f90f5;
        font-size: 0.24rem;
        vertical-align: top;
        color: #333333;
      }
      .info {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        display: flex;
        justify-content: space-between;
        font-size: 0.14rem;
        color: #696969;
        vertical-align: bottom;
      }
      .digest {
        // text-indent: 2em;
        font-size: 0.22rem;
        color: #696969;
        line-height: 0.26rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        overflow: hidden;
        -webkit-box-orient: vertical;
      }
    }
  }
  .no-data {
    text-align: center;
    font-size: 0.14rem;
    color: #ccc;
    background: #fff;
  }
}
</style>
